import { ExportCustomization } from "@/components/MedicalChronology/ExportCustomization";
import { useMedicalChronology } from "@/components/MedicalChronology/contexts/MedicalChronologyContext";
import { useCaseService } from "@/hooks/useCaseService";
import React, { useCallback, useState } from "react";
import { toast } from "react-hot-toast";

import { MedicalChronologyHeaderView } from "./MedicalChronologyHeaderView";

export const MedicalChronologyHeader: React.FC = () => {
  const {
    caseId,
    updateCaseName,
    physicianName,
    caseStatusId,
    firmContext,
    markCaseReviewed,
    templateId,
    navigate,
    selectedVersionId,
    caseName,
  } = useMedicalChronology();
  const [isCustomizeExportOpen, setIsCustomizeExportOpen] = useState(false);
  const caseService = useCaseService();

  const handleCaseNameSaved = useCallback(
    async (newCaseName: string) => {
      try {
        await caseService.renameCase(caseId, newCaseName);
        updateCaseName(newCaseName);
      } catch (error) {
        console.error("Error updating case name:", error);
        toast.error("Failed to update case name");
      }
    },
    [caseId, caseService, updateCaseName]
  );

  return (
    <>
      <MedicalChronologyHeaderView
        caseId={caseId}
        caseName={caseName}
        physicianName={physicianName}
        caseStatusId={caseStatusId}
        firmContext={firmContext}
        onMarkReviewed={markCaseReviewed}
        templateId={templateId}
        navigate={navigate}
        selectedVersionId={selectedVersionId}
        onCustomizeExport={() => setIsCustomizeExportOpen(true)}
        onCaseNameSaved={handleCaseNameSaved}
      />
      {isCustomizeExportOpen && (
        <ExportCustomization
          caseId={caseId}
          caseName={caseName}
          onClose={() => setIsCustomizeExportOpen(false)}
        />
      )}
    </>
  );
};
